const byteFormatter = new Intl.NumberFormat('en', {
  notation: 'compact',
  style: 'unit',
  unit: 'byte',
  unitDisplay: 'narrow',
  maximumFractionDigits: 1
})

/** Format a byte count as a human-readable string (e.g. 1536 → "1.5kB"). */
export const formatBytes = (bytes: number): string => byteFormatter.format(bytes)
